import {Component, Input} from '@angular/core';
import {FormBaseComponent, ValidatorService} from '@utils-lib';
import {Postfachadresse} from '@nachdigal';
import {FormBuilder} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {DatevMessageService} from '@datev/ngx-ui-components';

@Component({
    selector: 'common-ui-postfachadresse',
    templateUrl: './postfachadresse.component.html'
})
export class PostfachadresseComponent extends FormBaseComponent<Postfachadresse> {

    @Input()
    public showPostfachAdresse: boolean;

    constructor(private readonly formBuilder: FormBuilder,
                private readonly validatorService: ValidatorService,
                private readonly translateService: TranslateService,
                protected readonly messageService: DatevMessageService) {
        super(messageService);
    }

    protected createForm(): void {
        this.form = this.formBuilder.group({
            postfach: [this.data.postfach, [
                this.validatorService.maxLength(6),
                this.validatorService.required(),
                this.validatorService.pattern('^[0-9]*$',
                    this.translateService.instant('COMMON_UI.VALIDATION.POSTFACH_INVALID_PATTERN'))
            ]],
            postleitzahl: [this.data.postleitzahl, [
                this.validatorService.pattern('^[0-9]{5,5}$',
                    this.translateService.instant('COMMON_UI.VALIDATION.PLZ_INVALID_PATTERN')),
                this.validatorService.required()
            ]],
            ort: [this.data.ort, [
                this.validatorService.maxLength(72),
                this.validatorService.required(),
                this.validatorService.pattern('^[^\\d]*$',
                    this.translateService.instant('COMMON_UI.VALIDATION.ORT_INVALID_PATTERN'))
            ]]
        });
    }
}
